{
  "title": "How to Search the Platform Audit Log",
  "description": "Search platform-wide operation audit records, filtered by actor, target, competition, or time.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you can look up sensitive operations across the platform, including who did it, when, to whom, and why.",
  "roleNote": "Platform Administrator",
  "prerequisites": ["You hold the platform audit-log read capability"],
  "pathLabel": "Platform Administration → Audit Log",
  "steps": [
    {
      "title": "1. Open the audit log list",
      "description": "The list is sorted newest first and is server-side paginated — it never loads the platform's full history at once."
    },
    {
      "title": "2. Filter as needed",
      "description": "Filter by actor, affected (target) user, competition, action type, and a from/to date range; multiple filters can be combined."
    },
    {
      "title": "3. View a single record",
      "description": "Each record includes the action type, the entity's type and name (when that entity type has a name, e.g. a team, competition, or user — types without a name, like a form or round, show blank), the associated competition (if any), the actor's display name/email, the timestamp, and a reason (when that action requires one). Email-related actions are listed as well, for example \"emailed an announcement\", \"sent a registration update reminder\" and \"the system sent notification emails\" (recording the sent and failed counts for advancement, returned submissions, rejected eligibility proofs and judge invitations, with no email addresses)."
    }
  ],
  "afterward": [
    "You can trace the complete history of sensitive operations (suspensions, permission revocations, result lock/publish, deadline changes, etc.) through this list"
  ],
  "nextSteps": "To act on a specific user's anomaly, pair this with \"How to Manage Platform Users\" to look up that user's account status and take action.",
  "faq": [
    {
      "q": "Does an audit record's actor role reflect their role at the time of the action, or their current role?",
      "a": "It reflects the actor's CURRENT role, not a snapshot from when the action happened. The audit record itself doesn't store the actor's role at that time, so if that actor was later promoted or demoted, the historical record's role label reflects today's status, not the status at the time."
    },
    {
      "q": "Does every audit record have a reason filled in?",
      "a": "Not necessarily. A reason only appears when the system requires that particular action to have one (e.g. suspending an account, or rejecting/requesting changes on a competition request); actions that don't require a reason leave this field blank."
    },
    {
      "q": "Can an audit record be edited or deleted?",
      "a": "No. The audit log interface is entirely read-only — the system provides no operation to edit or delete an existing audit record, which is what keeps the audit trail's integrity intact."
    }
  ]
}
